export default __webpack_public_path__ + "static/media/pattern.0c016c73.svg";